import { toDisplayHtml } from '../lib/richText';

interface RichTextProps {
  /** Стойността от админ панела - HTML от редактора или стар обикновен текст. */
  value: string;
  className?: string;
}

/**
 * Показва текст, въведен с редактора в админ панела. Стиловете на таговете са
 * в index.css, под класа .rich-text.
 */
const RichText = ({ value, className = '' }: RichTextProps) => {
  if (!value) return null;

  return (
    <div
      className={`rich-text ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: toDisplayHtml(value) }}
    />
  );
};

export default RichText;
